import * as React from 'react';
import Typography from '@mui/material/Typography';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
} from '@mui/material';
import styles from './styles';

export default function Accordions({
  summary,
  details,
  summaryProps,
  detailsProps,
  smallIcon,
  isOpen,
  ...props
}) {
  return (
    <Accordion disableGutters elevation={0} square {...props} expanded={isOpen}>
      <AccordionSummary
        aria-controls="panel1d-content"
        id="panel1d-header"
        expandIcon={<Box sx={styles.icon(smallIcon)} />}
        sx={
          smallIcon
            ? {
                '& .MuiAccordionSummary-content': {
                  marginLeft: '0px',
                },
              }
            : {}
        }
      >
        {typeof summary === 'string' && (
          <Typography
            component={'h3'}
            variant="desktopH4"
            color="kit.text.h"
            sx={{
              maxWidth: {
                xs: '100%',
                md: '830px',
              },
            }}
            {...summaryProps}
          >
            {summary}
          </Typography>
        )}

        {typeof summary !== 'string' && summary}
      </AccordionSummary>
      <AccordionDetails {...detailsProps}>
        {typeof details === 'string' && (
          <Typography
            variant="desktopP2"
            color="kit.text.secondary"
            dangerouslySetInnerHTML={{ __html: details }}
            sx={{
              ...styles.content,
              '& a': {
                overflowWrap: 'break-word',
              },
            }}
          />
        )}

        {typeof details !== 'string' && details}
      </AccordionDetails>
    </Accordion>
  );
}
